import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrokerRenewalSuccessComponent } from './broker-renewal-success.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [BrokerRenewalSuccessComponent],
  imports: [
    CommonModule,
    MatDividerModule,
    MatIconModule
  ]
})
export class BrokerRenewalSuccessModule { }
